var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notification',{attrs:{"is-read":_vm.isRead,"created-at":_vm.createdAt},on:{"click":_vm.handleClick}},[_c('h2',{staticClass:"truncate"},[_vm._v("Récurrence")]),_vm._v(" "),_c('p',[_vm._v("Une commande récurrente n'a pas pu être générée.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }